const ALL_AD_SLOTS: Record<
  string,
  {
    id: string;
    size: [number, number] | [number, number][];
    sizeMapping?: { mobile?: [number, number]; desktop?: [number, number] };
    config?: googletag.config.SlotSettingsConfig;
  }
> = {
  above_header: {
    id: 'above_header',
    size: [970, 250],
    sizeMapping: { desktop: [970, 250] }
  },
  header_mobile: {
    id: 'header_mobile',
    size: [300, 250],
    sizeMapping: { mobile: [300, 250] }
  },
  above_footer: {
    id: 'above_footer',
    size: [
      [300, 250],
      [970, 250]
    ],
    sizeMapping: { mobile: [300, 250], desktop: [970, 250] }
  },
  above_news_cards: {
    id: 'above_news_cards',
    size: [
      [300, 250],
      [970, 250]
    ],
    sizeMapping: { mobile: [300, 250], desktop: [970, 250] }
  },
  below_top_stories: {
    id: 'below_top_stories',
    size: [
      [300, 250],
      [970, 250]
    ],
    sizeMapping: { mobile: [300, 250], desktop: [970, 250] }
  },
  between_news_cards: {
    id: 'between_news_cards',
    size: [
      [300, 250],
      [970, 250]
    ],
    sizeMapping: { mobile: [300, 250], desktop: [970, 250] }
  },
  article_inside: {
    id: 'article_inside',
    size: [300, 250],
    sizeMapping: { desktop: [300, 250] }
  },
  latest_rhs: {
    id: 'latest_rhs',
    size: [300, 600],
    sizeMapping: { desktop: [300, 600] }
  },
  article_rhs: {
    id: 'article_rhs',
    size: [300, 600],
    sizeMapping: { desktop: [300, 600] }
  }
};

const WRAPPER_CLASS_NAMES = {
  WIDE_AD: 'wide-ad',
  HALF_PAGE_ADS: 'half-page-ad-container'
  // LEADERBOARD_ADS: 'leaderboard-ad-container leaderboard-ad--',
  // MOBILE_LEADERBOARD_ADS: 'mobileleaderboard-ad-container',
  // NEWS_ADS: 'news-ad-container',
};

export { ALL_AD_SLOTS, WRAPPER_CLASS_NAMES };
